import { Text, View } from "@react-pdf/renderer";
import styles from '../styles/styles';
import Element from "./element";

interface CascadeProps {
  labels: {
    header: string;
    subHeader: string;
  };
  data: {
    jusitfication: string | null | undefined;
  };
}

const Cascade = ({ labels, data }: CascadeProps) => (
  <>
    <View style={styles.row}>
      <Text style={styles.subHeader}>{labels.header}</Text>
    </View>

    {data.jusitfication !== undefined && <>
      <View style={styles.miniSpacer} />

      <View style={styles.row}>
        <Element label={labels.subHeader} data={data.jusitfication} />
      </View>
    </>}
  </>
);

export default Cascade;